import * as yup from "yup";

export const sectionItemSchema = yup.object().shape({
  itemTitle: yup.string().required("checklistBuilder_section_item_title_required"),
});
